module.exports = require("@material-ui/core/InputLabel");